import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import ApiService from "../../Api/ApiController"; // adjust path if needed
import Swal from "sweetalert2";

export default function StocksList() {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories,setCategories] = useState([]);
  // edit state
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
   const [openDelete, setOpenDelete] = useState(false);
  const [formData, setFormData] = useState({
    company_name: "",
    current_price: "",
    price_change: "",
    change: "",
    symbol: "",
    direction: "",
  });

    const getCategory = ()=>{
      ApiService.getStockCategory().then((response)=>{
        if(response.data.status === true){
             setCategories(response.data.data)
        }else{
            setCategories([])
        }
      }).catch((error)=>{
        console.log(error)
        setCategories([])
      })
    }
  
  useEffect(() => {
    fetchStocks();
     getCategory()
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await ApiService.getAllStocks();
      setStocks(response.data.data);
    } catch (error) {
      console.error("Error fetching stocks:", error);
    } finally {
      setLoading(false);
    }
  };

  // ---- Edit Handling ----
  const handleEditOpen = (stock) => {
    setSelectedStock(stock);
    setFormData({
      company_name: stock.company_name,
      current_price: stock.current_price,
      price_change: stock.price_change,
      change: stock.change,
      symbol: stock.symbol,
      direction: stock.direction,
          stock_category_id: stock.stock_category?._id || "",  // ✅ set category id

    });
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
    setSelectedStock(null);
  };

  const handleEditSave = async () => {
    try {
     const response = await ApiService.updateStock(selectedStock._id, formData);
     if(response.data.status === true){
        Swal.fire({
                      toast: true,
                      position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                      icon: 'success',
                      title: response.data.message,
                      showConfirmButton: false,
                      timer: 3000, // Duration in milliseconds
                      timerProgressBar: true,
                    });
     }else{
        Swal.fire({
                      toast: true,
                      position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                      icon: 'error',
                      title: response.data.message,
                      showConfirmButton: false,
                      timer: 3000, // Duration in milliseconds
                      timerProgressBar: true,
                    }); 
     }
      await fetchStocks();
      handleEditClose();
    } catch (error) {
      console.error("Error updating stock:", error);
    }
  };

  // ---- Delete Handling ----
  const handleDeleteopen = (stock)=>{
    setSelectedStock(stock);
    setOpenDelete(true)
  }
  const handleDelete = async (id) => {
    
      try {
       const response =  await ApiService.deleteStock(selectedStock._id);
         if(response.data.status === true){

        Swal.fire({
                      toast: true,
                      position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                      icon: 'success',
                      title: response.data.message,
                      showConfirmButton: false,
                      timer: 3000, // Duration in milliseconds
                      timerProgressBar: true,
                    });
     }else{
        Swal.fire({
                      toast: true,
                      position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                      icon: 'error',
                      title: response.data.message,
                      showConfirmButton: false,
                      timer: 3000, // Duration in milliseconds
                      timerProgressBar: true,
                    }); 
     }
        await fetchStocks();
        setOpenDelete(false)
      } catch (error) {
        console.error("Error deleting stock:", error);
      }
  };

  return (
    <Card className="user_view_stocks_list">
      <CardHeader
        title="Stocks List"
        sx={{ textAlign: "center", fontWeight: "bold" }}
      />
      <CardContent>
        {loading ? (
          <CircularProgress />
        ) : stocks.length === 0 ? (
          <Typography variant="body1" align="center">
            No stocks available
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Stock Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Current Price</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Change Price</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Change</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Symbol</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Direction</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stocks.map((stock, index) => (
                  <TableRow key={stock._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{stock.company_name}</TableCell>
                    <TableCell>{stock.current_price}</TableCell>
                    <TableCell>{stock.price_change}</TableCell>
                    <TableCell>{stock.change}</TableCell>
                    <TableCell>{stock.symbol}</TableCell>
                    <TableCell>{stock.stock_category?.name}</TableCell>
                    <TableCell>{stock.direction.toUpperCase()}</TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        onClick={() => handleEditOpen(stock)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteopen(stock)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>

      {/* ---- Edit Dialog ---- */}
      <Dialog open={openEdit} onClose={handleEditClose} fullWidth>
        <DialogTitle>Edit Stock</DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            label="Stock Name"
            fullWidth
            value={formData.company_name}
            onChange={(e) =>
              setFormData({ ...formData, company_name: e.target.value })
            }
          />
            <TextField
                select
                fullWidth
                label="Category"
                name="stock_category_id"
                value={formData.stock_category_id}
                onChange={(e)=>{
                    setFormData({ ...formData, stock_category_id: e.target.value })
                }}
              >
                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </TextField>
          <TextField
            margin="dense"
            label="Current Price"
            fullWidth
            value={formData.current_price}
            onChange={(e) =>
              setFormData({ ...formData, current_price: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Price Change"
            fullWidth
            value={formData.price_change}
            onChange={(e) =>
              setFormData({ ...formData, price_change: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Change (%)"
            fullWidth
            value={formData.change}
            onChange={(e) =>
              setFormData({ ...formData, change: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Symbol"
            fullWidth
            value={formData.symbol}
            onChange={(e) =>
              setFormData({ ...formData, symbol: e.target.value })
            }
          />
           <TextField
                select
                fullWidth
                label="Direction"
                name="direction"
                value={formData.direction}
                   onChange={(e) =>
              setFormData({ ...formData, direction: e.target.value })
            }
              >
                <MenuItem value="up">Up</MenuItem>
                <MenuItem value="down">Down</MenuItem>
              </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button onClick={handleEditSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

       <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent dividers>
                <Typography>
                  Are you sure you want to delete stock{" "}
                  <strong>{selectedStock?.name}</strong>?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
    </Card>
  );
}
